module.exports = __webpack_public_path__ + "img/ic-arrow-down-red.20f855dc.svg";